export default "__VITE_ASSET__BZSK0vLM__"